// Старые обработчики апи подменяют ст=атус 0 респонза на 408, меняем взад и обрабатываем как обрыв соединения
import { HttpErrorCodes } from 'reactApp/api/HttpErrorCodes';

export const getResponseStatusCodeFromOldApi = (status?: number) =>
    !status || status === HttpErrorCodes.REQUEST_TIMEOUT ? 0 : (status as number);
